import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import config from "../../config/config";
import endpoint from "../../config/endpoints";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import {
  importedMsg,
  importFailedMsg,
  importWarningMsg,
  noInternetMsg,
  noValidatedRecordsFoundMsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiGet, apiPost, apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";

import ValidatePopUpForGeographical from "./ValidatePopUpForGeographical";
import SelectFilePopUp from "../Master Data Import Export/SelectFilePopUp";

class GeographicalMasterImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: "",
      selectFilePopUpFlag: false,
      validateDataTablePopUpFlag: false,
      moduleDataList: [],
      validateDataList: [],
      columnTag: "",
      validationTableTitle: "",
      dynamicMasterData: {},
      fileName: "",
      isValidating: false,
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiGet({
        url: endpoint.importExportExcelData + "/by-module-wise?flag=1 ",
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          let moduleDataList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              moduleName: dataObj.moduleName !== null ? dataObj.moduleName : "",
              name: dataObj.moduleName !== null ? dataObj.moduleName : "",
              moduleId: dataObj.moduleId !== null ? dataObj.moduleId : "",
              subModuleId: dataObj.subModuleId !== null ? dataObj.moduleId : "",
              ...dataObj,
            };
          });

          this.setState({
            moduleDataList,
            option: moduleDataList[0].id,
          });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onAutocompleteChange = () => (name, newValue) => {
    if (newValue != null) {
      this.setState({
        option: newValue,
        fileName: "",
      });
    }
  };

  onExportHandler = () => {
    const { option, moduleDataList } = this.state;
    const { showLoador, showNotification } = this.props;

    let matchedDataObj = moduleDataList.find((row) => row.id === option);

    showLoador({ loador: true });
    downloadF({
      isGet: true,
      url: config.urlStart + matchedDataObj.exportUrl,
      ext: "xls",
      openNewTab: false,
    }).then((response) => {
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
      showLoador({ loador: false });
    });
  };

  changeH = (fileName, name, index) => {
    this.setState({
      ...this.state,
      fileName: fileName,
    });
  };

  onClickViewPreview = (e, row) => {
    e.stopPropagation();
    const url = URL.createObjectURL(row);
    window.open(url);
  };

  onClearHandler = (event, value) => {
    this.setState({
      ...this.state,
      fileName: "",
    });
  };

  onValidate = async () => {
    const { fileName, option, moduleDataList } = this.state;
    const { showLoador, showNotification } = this.props;

    let columnTag = "";

    let validationTableTitle = "";

    let matchedDataObj = moduleDataList.find((row) => row.id === option);

    if (matchedDataObj.moduleId == 1) {
      if (matchedDataObj.subModuleId == 1) {
        columnTag = 1; //RegiontoAreaHierarchy
        validationTableTitle = "Validate Region to Area Hierarchy";
      } else if (matchedDataObj.subModuleId == 2) {
        columnTag = 2; //region
        validationTableTitle = "Validated region";
      } else if (matchedDataObj.subModuleId == 3) {
        columnTag = 3; //country
        validationTableTitle = "Validated country";
      } else if (matchedDataObj.subModuleId == 4) {
        columnTag = 4; //zone
        validationTableTitle = "Validated zone";
      } else if (matchedDataObj.subModuleId == 5) {
        columnTag = 5; //district
        validationTableTitle = "Validated district";
      } else if (matchedDataObj.subModuleId == 6) {
        columnTag = 6; //taluka
        validationTableTitle = "Validated taluka";
      } else if (matchedDataObj.subModuleId == 7) {
        columnTag = 7; //area
        validationTableTitle = "Validated area";
      }
    }

    let excelName = matchedDataObj.extra3;

    if (!fileName) {
      showNotification({
        msg: "Please select file",
        severity: "error",
      });
      return;
    }

    const formData = new FormData();
    let importUrl = config.urlStart + matchedDataObj.importValidateUrl;

    formData.append(excelName, fileName);

    this.setState({ isValidating: true });
    await apiPostForImage({
      url: importUrl,
      postBody: formData,
    }).then(({ data, success }) => {
      if (success) {
        let validateDataList = data.data;

        this.setState({ validateDataList, columnTag, validationTableTitle });

        showNotification({
          msg: "File validate Successfully",
          severity: "success",
        });

        this.setState({
          isValidating: false,
          validateDataTablePopUpFlag: true,
        });
      } else {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onImportValidatedData = async () => {
    const { validateDataList, option, moduleDataList } = this.state;
    const { showLoador, showNotification } = this.props;

    let validatedRecordPresent = validateDataList.some((row) => row.flag == 0);

    let matchedDataObj = moduleDataList.find((row) => row.id === option);

    let importUrl = config.urlStart + matchedDataObj.importValidatedUrl;

    if (!validatedRecordPresent) {
      showNotification({ msg: noValidatedRecordsFoundMsg, severity: "error" });
      return;
    }

    swal({
      title: "Are you sure?",
      text: importWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: importUrl,
          postBody: validateDataList,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (success) {
            showNotification({
              msg: importedMsg,
            });
            window.location.replace("/geographical-import-export");
          } else {
            showNotification({
              msg: importFailedMsg,
              severity: "error",
            });
          }
        });
      }
    });
  };

  onClickOfImport = () => {
    this.setState({ selectFilePopUpFlag: true });
  };

  handleClosesForFilePopUp = () => {
    this.setState({ selectFilePopUpFlag: false });
  };

  handleClosesForValidatePopUp = () => {
    this.setState({ validateDataTablePopUpFlag: false });
  };

  render() {
    const {
      option,
      fileName,
      selectFilePopUpFlag,
      validateDataTablePopUpFlag,
      moduleDataList,
      validateDataList,
      columnTag,
      validationTableTitle,
      isValidating,
    } = this.state;
    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
            maxWidth: "auto",
            margin: "auto",
          }}
          elevation={5}
        >
          <LandingScreenHeader
            screenTitle="Import/Export Data"
            showSaveBtnMain={false}
            showAddButton={false}
            showBackButton={false}
          />

          <Box mt={3} mb={2}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              Select the module to import or export data.
            </Typography>
          </Box>

          <Grid container direction="row" spacing={4} alignItems="center">
            <Grid item>
              <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, fontWeight: 500 }}
                    label="Select Module :"
                  />
                </Grid>
                <Grid item xs>
                  <AutoComplete
                    keyColName="id"
                    value={option}
                    name="option"
                    options={moduleDataList}
                    onChange={this.onAutocompleteChange()}
                    placeholder="Choose a module..."
                    fullWidth
                    sx={{
                      ml: 1,
                      mt: 1,
                      borderRadius: 2,
                      minWidth: "480px",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                    sx={{
                      color: "#fff",
                      mr: 2,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      transition: "all 0.2s",
                      minWidth: "120px",
                      height: "35px",
                      "&:hover": {
                        backgroundColor: "#1976d2",
                        transform: "translateY(-2px)",
                      },
                    }}
                    onClick={this.onClickOfImport}
                  >
                    Import
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="medium"
                    startIcon={<CloudDownloadIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      transition: "all 0.2s",
                      minWidth: "120px",
                      height: "35px",
                      "&:hover": {
                        backgroundColor: "#f4f6fa",
                        borderColor: "#1976d2",
                        color: "#1976d2",
                        transform: "translateY(-2px)",
                      },
                    }}
                    onClick={this.onExportHandler}
                  >
                    Export
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {selectFilePopUpFlag && (
          <SelectFilePopUp
            open={selectFilePopUpFlag}
            fileName={fileName}
            changeH={this.changeH}
            handleCloses={this.handleClosesForFilePopUp}
            onClearHandler={this.onClearHandler}
            onValidate={this.onValidate}
            isValidating={isValidating}
          />
        )}

        {validateDataTablePopUpFlag && (
          <ValidatePopUpForGeographical
            open={validateDataTablePopUpFlag}
            handleCloses={this.handleClosesForValidatePopUp}
            validateDataList={validateDataList}
            onImportValidatedData={this.onImportValidatedData}
            columnTag={columnTag}
            validationTableTitle={validationTableTitle}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(GeographicalMasterImportExport);
